import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { appConfigService } from '@app/config';
import { AuthRequestOptions, ItemViewProviderDirective } from '@ntap/core';
import { ConfirmationService } from 'primeng/api';
import { first, map, Observable } from 'rxjs';
import { PrimeNGButtonActionComponent } from '@ntap/primeng';

@Component({
  selector: 'app-objava-odobjava-jedinice',
  templateUrl: './obustavi-rok-cuvanja-action.component.html'
})
export class ObustaviRokCuvanjaActionComponent extends PrimeNGButtonActionComponent {
  private itemViewProvider = inject(ItemViewProviderDirective);
  private confirmationService = inject(ConfirmationService);
  private httpClient = inject(HttpClient);
  private config = inject(appConfigService);

  messageTextObustava = 'Jeste li sigurni da želite obustaviti rok čuvanja?';
  messageTextUklanjanjeObustave =
    'Jeste li sigurni da želite ukloniti obustavu roka čuvanja?';
  headerTextObustava = 'Obustava roka čuvanja';
  headerTextUklanjanjeObustave = 'Uklanjanje obustave roka čuvanja';

  label$: Observable<string>;
  tooltip: string;
  public showDialog = false;
  public message: string;
  public header: string;
  public razlogObustave: string;

  protected override initDisabledObservable(): void {
    super.initDisabledObservable();
    this.isDisabled$ = this.isDisabled$ = this.itemProvider.item$.pipe(
      map((item) => (item as any)['sv~rok_cuvanja~id'] === 0)
    );
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  override executeAction(event: any): void {
    this.itemViewProvider.item$.pipe(first()).subscribe((item) => {
      const obustavljen = (item as any)['$obustavljen'];
      if (obustavljen) {
        this.message = this.messageTextUklanjanjeObustave;
        this.header = this.headerTextUklanjanjeObustave;
      } else {
        this.message = this.messageTextObustava;
        this.header = this.headerTextObustava;
      }

      this.confirmationService.confirm({
        message: this.message,
        header: this.header,
        icon: 'pi pi-info-circle',
        accept: () => {
          this.httpClient
            .post(
              `${this.config.apiHost}obustava-roka-cuvanja`,
              item,
              new AuthRequestOptions()
            )
            .pipe(first())
            .subscribe({
              next: () => {
                const message = 'Rok čuvanja je obustavljen.';
                this.notificationService.success(message);
                this.itemViewProvider.reload();
              },
              error: () => {
                const errorMessage = 'Rok čuvanja neuspješno obustavljen!';
                this.notificationService.error(errorMessage);
              }
            });
        }
      });
    });
  }
}
